/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface PatientMinDTO { 
    /**
     * The patient's birth date
     */
    birthDate?: Date;
    /**
     * The patient's healthCard
     */
    healthCard?: string;
    /**
     * The patient's name
     */
    name?: string;
    /**
     * The patient's surname
     */
    surname?: string;
    /**
     * The patient's uniqueCode
     */
    uniqueCode?: string;
    /**
     * The patient's uuid
     */
    uuid?: string;
}
